/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import './DownloadAttachment.scss';
import Dragger from 'antd/lib/upload/Dragger';
import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface Props {
    rtl: boolean;
    downloadForm: boolean;
    title: string;
    subTitle: string;
    uploadFileText: string;
    toolTipText: string;
    downloadFileSrc?: string;
    fileType?: string[] | any[];
    sizeErrorText?: string;
    fileTypeErrorText?: string;
    filemaxErrorText?: string;
    selectFileHandler?: any;
    errorMessageHandler?: any;
    userType: string[];
    name: string;
    rules?: any;
    selectFileErrorText?: string;
    sizeError?: string;
    fileFormatError?: string;
    selectFileError: boolean;
    fileSupportPlaceholder?: string;
}

function UploadDocument({
    rtl,
    title,
    subTitle,
    name,
    rules,
    errorMessageHandler,
    selectFileHandler,
    fileSupportPlaceholder = `Supports: JPG, PNG, PDF, EXCEL, email, WORD, TXT and MSG`,
    selectFileErrorText,
    sizeErrorText = "The attached file shouldn’t exceed 2 MB",
    fileFormatError = "Please upload a file with the format of bmp, gif, jpe, ipeg, png, jpg, tiff, tif, jfif, doc, docx, pdf, xlsx, msg, xls, txt, csv, rtf only",
    fileType = [
        "image/bmp",
        "image/gif",
        "image/jpeg",
        "image/tiff",
        "image/png",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "application/vnd.ms-outlook",
        ".msg",
        "text/plain",
        "text/csv",
        "application/rtf",
    ],
}: Props) {
    const [file, setFile] = useState<any>([]);
    const [error, setError] = useState<string>("");
    const { t } = useTranslation();
    useEffect(() => {
        if (selectFileErrorText) {
            setError(selectFileErrorText);
            setFile([]);
            errorMessageHandler(name, selectFileErrorText);
        }
    }, [selectFileErrorText]);
    const dir = rtl ? 'right' : 'left';
    const beforeUpload = (file: any) => {
        const fileSize = Math.round(file.size / (2 * 1024));
        const ele = { name, alt: 'upload-icon' }
        console.log(fileSize, 'fileSize', file)
        if (fileSize > (2 * 1024)) {
            setError(sizeErrorText);
            errorMessageHandler(name, sizeErrorText);
            setFile([]);
        } else if (!file) {
            setError(selectFileErrorText);
            errorMessageHandler(name, selectFileErrorText);
            setFile([]);
        } else if (file.type === "") {
            const index = file.name.lastIndexOf(".");
            const type = file.name.substring(index);
            if (fileType.includes(type)) {
                setError("");
                setFile([file]);
                selectFileHandler(ele, file);
                errorMessageHandler(name, "");
            } else {
                setError(fileFormatError);
                errorMessageHandler(name, fileFormatError);
                setFile([]);
            }
        } else if (!fileType.includes(file.type)) {
            setError(fileFormatError);
            errorMessageHandler(name, fileFormatError);
            setFile([]);
        } else {
            setError("");
            setFile([file]);
            selectFileHandler(ele, file);
            errorMessageHandler(name, "");
        }
        return false;
    }
    const props = {
        name,
        multiple: false,
        beforeUpload,
        onChange(info: any) {
            const { status } = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                console.log(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                console.error(`${info.file.name} file upload failed.`);
            }
            if (status === 'removed') {
                setFile([]);
            }

        },
        onDrop(e: any) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };
    const getFile = (e: any) => {
        console.log('Upload event:', e);

        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    return (
        <div className={`upload-document-container text-${dir} col-sm-7`}>
            <div>
                <Typography className={`upload-title fontFamily-${dir}`} rtl={rtl}>{title}</Typography>
                <Typography className={`upload-subtitle`} rtl={rtl}>{subTitle}</Typography>
            </div>
            <Form.Item
                rules={rules}
                name={name}
                help={error ? error : ''}
                validateStatus={error ? 'error' : ''}
                getValueFromEvent={getFile}
            >
                <Dragger accept={fileType.join(',')} fileList={file} {...props}>
                    <p className="ant-upload-drag-text">{t("Drag_your_file_here_or")}<span className='browse-link'>{' ' + t("browse")}</span></p>
                    <p className="ant-upload-drag-hint">
                        {t('Supports')}: {fileSupportPlaceholder}
                    </p>
                    <p className="ant-upload-size-hint">
                        {t("Max_Allowed_file_size_is")}
                    </p>
                </Dragger>
            </Form.Item>
        </div>
    )
}

export default UploadDocument
